import { render, staticRenderFns } from "./TipBlock.vue?vue&type=template&id=51f384c9&scoped=true&"
import script from "./TipBlock.vue?vue&type=script&lang=ts&"
export * from "./TipBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TipBlock.vue?vue&type=style&index=0&id=51f384c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f384c9",
  null
  
)

export default component.exports